import React from 'react';
import FilterChips from '../components/FilterChips';
import { useFilter } from '../components/FilterContext';
import { Filter } from '../filter-state';

const FilterChipsView = () => {
  const { getFilters, toggleFilterEnabled, toggleFilterSelect } = useFilter();

  const selectedFilters = getFilters().filter((filter: Filter) => filter.selected);

  return (
    <FilterChips
      filters={selectedFilters}
      toggleFilter={toggleFilterEnabled}
      removeFilter={toggleFilterSelect}
    />
  );
};

export default FilterChipsView;
